/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { endOfMonth } from 'date-fns';
import BarChart from 'Shared/components/charts/bar-chart';
import { getYearAndMonth } from 'Shared/util/formatters';
import styles from './debtor-chart.css';

const extendOptions = (options) => ({
  ...options,
  onHover: (event, chartElement) => {
    event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
  },
});


const DebtorBarChart = ({
  headerText,
  label,
  data,
  options,
  history,
  debtor,
}) => {
  const getFilterDates = (element) => {
    const yearMonth = getYearAndMonth(element[0]._model.label);
    const fromDate = new Date(yearMonth[0], (yearMonth[1] - 1));

    return {
      fromDate,
      toDate: endOfMonth(fromDate),
    };
  };

  const handleOnElementsClick = (element) => {
    const filterDates = getFilterDates(element);
    history.push({
      pathname: '/invoices-payed',
      state: {
        fromDate: filterDates.fromDate,
        toDate: filterDates.toDate,
        debtor,
      },
    });
  };

  return (
    <div>
      <h3 className={styles.title}>
        {headerText}
      </h3>
      <div className={styles.barChartContainer}>
        <BarChart
          label={label}
          data={data}
          options={extendOptions(options)}
          onElementsClick={handleOnElementsClick}
        />
      </div>
    </div>
  );
};

DebtorBarChart.propTypes = {
  headerText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  debtor: PropTypes.string,
};

export default withRouter(DebtorBarChart);
